import {
    CONFIRMED_CREATE_LANDING_ACTION,
    CONFIRMED_DELETE_LANDING_ACTION,
    CONFIRMED_EDIT_LANDING_ACTION,
    CONFIRMED_GET_LANDINGS,
    CREATE_LANDING_ACTION,    
    CREATE_LANDING_ERROR_ACTION,
    CLEAR_LANDING_ERROR,
    LOADING_LANDINGS
} from '../actions/LandingTypes';

const initialState = {
    landings: [],
    loading: false,
    createLandingError: {}
};

export default function LandingReducer(state = initialState, actions) {
    if (actions.type === CREATE_LANDING_ACTION) { 
        return {
            ...state,
            landings: [...state.landings],
        };
    }

    if (actions.type === CONFIRMED_DELETE_LANDING_ACTION) {
        const landings = state.landings.filter(landing => landing.id !== actions.payload);
        return {
            ...state,
            landings,
        };
    }

    if (actions.type === CONFIRMED_EDIT_LANDING_ACTION) {
        const landings = state.landings.map(landing => 
            landing.id === actions.payload.id ? actions.payload : landing
        );
        return {
            ...state,
            landings,
        };
    }

    if (actions.type === CONFIRMED_CREATE_LANDING_ACTION) {
        return {
            ...state,
            landings: [...state.landings, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_LANDINGS) {
        return {
            ...state,
            landings: actions.payload,
        };
    }

    if (actions.type === LOADING_LANDINGS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_LANDING_ERROR_ACTION) {
        return {
            ...state,
            createLandingError: actions.payload,
        };
    }

    if (actions.type === CLEAR_LANDING_ERROR) {
        return {
            ...state,
            createLandingError: {},
        };
    }
    
    return state;
}
